export const Fields = {
  username: 'username',
  website: 'entities[0].website',
  routing: 'routing',
  ein: 'entities[0].ein',
  phone: 'phone',
  contactPhone: 'entities[0].merchant.members[0].phone',
  established: 'entities[0].merchant.established',
  title: 'entities[0].merchant.members[0].title',
};

// 1 to 1 mapping
export const FieldToFormlyField = {
  [Fields.username]: 'contact.account.username',
  [Fields.website]: 'business.website',
  [Fields.routing]: 'routingNumber',
  [Fields.ein]: 'business.tin',
  [Fields.phone]: 'business.businessPhone',
  [Fields.contactPhone]: 'contact.phoneNumber',
  [Fields.established]: 'business.established',
  [Fields.title]: 'contact.businessTitle',
};

/**
 * Transforms Payment Provider (Payrix) field to Merchant Application field
 * @param field
 * @returns
 */
export const getFormlyFieldKey = (field: string) => {
  if (FieldToFormlyField[field]) {
    return FieldToFormlyField[field];
  }

  // Payrix uses bracket notation for arrays, whereas Angular Forms uses dot notation
  field = field.replaceAll('[', '.');
  field = field.replaceAll(']', '');

  if (field.includes('entities.0.accounts')) {
    field = field.replace('entities.0.accounts', 'banking.banks');
    field = field.replace('.account', '');
  }

  const dbaRegex = /^entities\.(\d+)\.merchant\.dba/;
  const dbaMatch = field.match(dbaRegex);
  if (dbaMatch) {
    const index = dbaMatch[1];
    field = field.replace(dbaRegex, `banking.banks.${index}.dba`);
  }

  field = field
    .split('.')
    .map((partition) => FieldToFormlyField[partition] || partition)
    .join('.');

  return field;
};
